import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../components/layout/AppShell';
import useDocumentTitle from '../hooks/useDocumentTitle';
import '../styles/PrivacyPage.css';

function PrivacyPage() {
  const navigate = useNavigate();
  useDocumentTitle('سياسة الخصوصية');

  return (
    <AppShell>
      <div className="privacy-container">
        <button className="privacy-back-btn" onClick={() => navigate('/')}>
          ← العودة للرئيسية
        </button>

        <div className="privacy-card">
          <div className="privacy-icon">🔒</div>
          <h1 className="privacy-title">سياسة الخصوصية</h1>
          <p className="privacy-subtitle">Privacy Policy</p>

          <div className="privacy-section">
            <h2 className="privacy-section-title">🇸🇦 العربية</h2>
            <p className="privacy-text">
              تعتبر خصوصية وأمان مستخدمينا أولوية قصوى لنا. نحن ملتزمون بحماية بياناتكم الشخصية.
              نجمع فقط البيانات الضرورية مثل الاسم، ورقم الهاتف، والبلد. كما يتم تشفير جميع
              البيانات بشكل كامل، ونستخدم شهادات SSL لضمان أمان الاتصالات عبر خوادمنا. نلتزم
              بعدم مشاركة هذه البيانات مع أي طرف ثالث.
            </p>
          </div>

          <div className="privacy-divider" />

          <div className="privacy-section">
            <h2 className="privacy-section-title">🇬🇧 English</h2>
            <p className="privacy-text privacy-text-ltr">
              User privacy and security are our top priorities. We are committed to protecting your
              personal data. We collect only necessary information such as name, phone number, and
              country. All data is fully encrypted, and we use SSL certificates to ensure secure
              communication across our servers. We do not share this data with any third party.
            </p>
          </div>

          <button className="privacy-back-btn-bottom" onClick={() => navigate('/')}>
            ← العودة للصفحة الرئيسية
          </button>
        </div>
      </div>
    </AppShell>
  );
}

export default PrivacyPage;
